var exports = {
  "In": "TextualAttachmentPreview.module__textualPreview___X19wTj",
  "KR": "TextualAttachmentPreview.module__previewSurface___X19wTj",
  "cA": "TextualAttachmentPreview.module__previewActions___X19wTj",
  "wL": "TextualAttachmentPreview.module__previewActionsVisible___X19wTj",
  "VA": "TextualAttachmentPreview.module__previewActionButton___X19wTj" + " " + __webpack_require__(377561)["AS"],
  "nJ": "TextualAttachmentPreview.module__copyIcon___X19wTj",
  "fs": "TextualAttachmentPreview.module__inlinePreviewSurface___X19wTj",
  "vd": "TextualAttachmentPreview.module__previewViewport___X19wTj",
  "uL": "TextualAttachmentPreview.module__previewViewportCollapsed___X19wTj",
  "q4": "TextualAttachmentPreview.module__previewViewportExpanded___X19wTj",
  "Nv": "TextualAttachmentPreview.module__csvTableViewport___X19wTj",
  "rV": "TextualAttachmentPreview.module__csvTableMarkup___X19wTj",
  "uT": "TextualAttachmentPreview.module__previewCode___X19wTj",
  "O9": "TextualAttachmentPreview.module__previewCodeWrap___X19wTj",
  "VP": "TextualAttachmentPreview.module__previewError___X19wTj",
  "Ml": "TextualAttachmentPreview.module__loadingState___X19wTj",
  "qr": "TextualAttachmentPreview.module__footer___X19wTj",
  "X1": "TextualAttachmentPreview.module__expandButton___X19wTj" + " " + __webpack_require__(377561)["AS"],
  "eO": "TextualAttachmentPreview.module__expandIcon___X19wTj",
  "t2": "TextualAttachmentPreview.module__expandIconExpanded___X19wTj",
  "qt": "TextualAttachmentPreview.module__fileSection___X19wTj",
  "gM": "TextualAttachmentPreview.module__fileMeta___X19wTj",
  "Md": "TextualAttachmentPreview.module__fileName___X19wTj",
  "Ov": "TextualAttachmentPreview.module__fileSize___X19wTj",
  "zt": "TextualAttachmentPreview.module__footerActions___X19wTj",
  "uH": "TextualAttachmentPreview.module__controlButton___X19wTj" + " " + __webpack_require__(377561)["AS"],
  "RJ": "TextualAttachmentPreview.module__languagePositioner___X19wTj",
  "tP": "TextualAttachmentPreview.module__languagePopup___X19wTj",
  "Nl": "TextualAttachmentPreview.module__languageSearchWrap___X19wTj",
  "nb": "TextualAttachmentPreview.module__languageSearchInput___X19wTj",
  "qm": "TextualAttachmentPreview.module__languageEmpty___X19wTj",
  "xl": "TextualAttachmentPreview.module__languageList___X19wTj",
  "O6": "TextualAttachmentPreview.module__languageItem___X19wTj",
  "d6": "TextualAttachmentPreview.module__languageItemHighlighted___X19wTj",
  "J6": "TextualAttachmentPreview.module__languageItemSelected___X19wTj",
  "xu": "TextualAttachmentPreview.module__languageItemIndicator___X19wTj",
  "lh": "TextualAttachmentPreview.module__languageOptionContent___X19wTj",
  "XO": "TextualAttachmentPreview.module__languageOptionCode___X19wTj",
  "_s": "TextualAttachmentPreview.module__languageOptionCanonical___X19wTj",
  "CR": "TextualAttachmentPreview.module__modalRoot___X19wTj",
  "Ij": "TextualAttachmentPreview.module__modalLayout___X19wTj",
  "S3": "TextualAttachmentPreview.module__modalBody___X19wTj",
  "fn": "TextualAttachmentPreview.module__modalPreviewSurface___X19wTj",
  "CM": "TextualAttachmentPreview.module__previewViewportFill___X19wTj",
  "v6": "TextualAttachmentPreview.module__previewCodeFill___X19wTj",
};

module.exports = exports;
